@if (inputType) {
  <mat-expansion-panel class="mt-2" [expanded]="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (title) {
          {{ title }}
        } @else if (clientRole === 'client') {
          {{ 'DOCUMENTS.client_documents' | translate }}
        } @else if (clientRole === 'partner') {
          {{ 'DOCUMENTS.partner_documents' | translate }}
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-accordion multi>
      @if (isLoading) {
        <div class="text-center" style="padding: 50px">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      }
      @for (documentTypeCategory of caseDocumentTypeCategories; track documentTypeCategory) {
        <ng-container>
          @if (documentTypeCategory?.document_types?.length) {
            <mat-expansion-panel class="mt-2" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ documentTypeCategory['name_' + currentLanguage] }}
                  @if (documentTypeCategory.approval_status === 'pending') {
                    <mat-icon color="accent">error</mat-icon>
                  }
                  @if (documentTypeCategory.approval_status === 'accepted') {
                    <mat-icon color="primary">check_circle</mat-icon>
                  }
                  @if (documentTypeCategory.approval_status === 'rejected') {
                    <mat-icon color="warn">warning</mat-icon>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (documentType of documentTypeCategory.document_types; track documentType) {
                <mat-expansion-panel style="transition: none"
                                     [ngClass]="{
                                        'pending-file': !documentType.custom_input_logic && documentType.approval_status === 'pending',
                                        'accepted-file': !documentType.custom_input_logic && documentType.approval_status === 'accepted',
                                        'rejected-file': !documentType.custom_input_logic && documentType.approval_status === 'rejected'
                                      }"
                                     [expanded]="documentType.custom_input_logic"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ documentType['name_' + currentLanguage] }}
                      @if (documentType.has_pending_files) {
                        <mat-icon color="accent">error</mat-icon>
                      }
                      <!-- <mat-icon color="primary" *ngIf="documentType.approval_status === 'accepted'">check_circle</mat-icon> -->
                      <!-- <mat-icon color="warn" *ngIf="documentType.approval_status === 'rejected'">warning</mat-icon> -->
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <!--  Custom Documents creator -->
                  @if(customDocumentForm && documentType.custom_input_logic === 'custom_selection') {
                    <form class="form"
                          [formGroup]="customDocumentForm"
                          (ngSubmit)="addCustomDocument(customDocumentForm, documentType)">
                      <div class="row justify-content-between align-items-center mb-3">
                        <div class="col-12 col-md-6 col-lg-4">
                          <mat-form-field [appearance]="'outline'" subscriptSizing="dynamic" class="w-100">
                            <mat-label>{{ 'SHARED.name' | translate }}</mat-label>
                            <input matInput type="text" formControlName="document_name">
                            @if (customDocumentForm.get('document_name').invalid) {
                              <mat-error>{{"SHARED.field-required" | translate}}</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-auto mt-2 mt-md-0">
                          <button type="submit" mat-stroked-button color="primary" class="ml-3 button-outlined-primary">
                            {{ "CASES.single.documents.add_document" | translate }}
                          </button>
                        </div>
                      </div>
                    </form>
                  }
                  <!-- Document Uploader TODO: remove duplication -->
                  @if (!documentType?.documents?.length) {
                    <div class="row justify-content-end">
                      <div class="col-auto">
                        @if (documentType?.document_type_requests?.length) {
                          <button type="button" mat-button color="primary"
                                  (click)="deleteDocumentTypeRequest(documentType, documentType.document_type_requests[0])">
                            {{ 'CASES.single.documents.list.document.actions.cancel_document_request' | translate }}
                          </button>
                        }
                      </div>
                      @if (uploadForm
                      && (!documentType.custom_input_logic || documentType.custom_input_logic === 'case_asset_collection')
                      && !documentType?.documents?.length) {
                        <div [ngClass]="{'col-12': true, 'mt-4': documentType?.document_type_requests?.length}">
                          <form [formGroup]="uploadForm"
                                (ngSubmit)="uploadFiles(uploadForm, documentType, null)" class="form"
                          >
                            <div class="row justify-content-between">
                              <div class="col-12 col-md-6 col-xl-4">
                                <div class="form-group">
                                  <!-- <label -->
                                  <!--   [for]="'doc_type_upload_file_' + documentType.id">{{ "DOCUMENTS.upload_documents" | translate }}</label> -->
                                  <div class="input-group">
                                    <div class="custom-file">
                                      @if (inputType === 'dropzone') {
                                        <!--                            <mat-form-field appearance="fill" [id]="'doc_type_upload_file_' + documentType.id"-->
                                        <!--                                            (change)="fileSelected($event, documentType, null)">-->
                                        <!--                              <ngx-mat-dropzone>-->
                                        <!--                                <input type="file" fileInput multiple [formControl]="fileInput"/>-->
                                        <!--                              </ngx-mat-dropzone>-->
                                        <!--                              <mat-icon matSuffix color="primary">cloud_upload</mat-icon>-->
                                        <!--                            </mat-form-field>-->
                                      }
                                      @if (inputType === 'default') {
                                        <input multiple type="file" class="custom-file-input"
                                               [id]="'doc_type_upload_file_' + documentType.id"
                                               (change)="fileSelected($event, documentType, null)">
                                        <label class="custom-file-label"
                                               [for]="'doc_type_upload_file_' + documentType.id"
                                               style="width: auto;"
                                        >
                                          {{ 'DOCUMENTS.choose_file' | translate }}
                                        </label>
                                      }
                                    </div>
                                  </div>
                                  @if (uploadForm.get('app_document_type_id').value === documentType.id) {
                                    @for (file of selectedUploadFiles; track file.index) {
                                      <div class="d-flex justify-content-between align-items-center">
                                        <p class="m-0 uploaded-file-name">{{ file.name }}</p>
                                        <button type="button" mat-icon-button color="warn"
                                                (click)="removeSelectedFile(file.index)">
                                          <mat-icon class="text-danger mat-icon" aria-hidden="false"
                                                    aria-label="Example home icon">
                                            remove_circle
                                          </mat-icon>
                                        </button>
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                              @if (uploadForm.get('app_document_type_id').value === documentType.id
                              && selectedUploadFiles.length) {
                                <div class="col-auto mt-2 mt-md-0">
                                  <app-spinner-btn [loading]="isUploading" [name]="'SHARED.submit' | translate">
                                  </app-spinner-btn>
                                </div>
                              }
                            </div>
                          </form>
                        </div>
                      }
                      <!-- No Data -->
                      <div class="col-12 mt-4">
                        <h5 class="text-center user-document-list">
                          {{ "CASES.single.no_files_uploaded" | translate }}
                        </h5>
                      </div>
                    </div>
                  }
                  <!-- List all documents for document type -->
                  @for (document of documentType?.documents; track document) {
                    <mat-expansion-panel style="transition: none"
                                         class="mb-1 mat-elevation-z0"
                                         [ngClass]="{
                                            'pending-file': document.approval_status === 'pending',
                                            'accepted-file': document.approval_status === 'accepted',
                                            'rejected-file': document.approval_status === 'rejected',
                                            'mb-1': documentType.custom_input_logic,
                                            'mat-elevation-z0': !documentType.custom_input_logic
                                         }"
                                         [expanded]="!documentType.custom_input_logic"
                                         [hideToggle]="!documentType.custom_input_logic">
                      <!-- [expanded]="!!document.compiled_file || !!document.files.length"> -->
                      <mat-expansion-panel-header [ngClass]="{'d-none': !documentType.custom_input_logic}">
                        @if (documentType.custom_input_logic === 'case_creditor_selection' ||
                        documentType.custom_input_logic === 'case_public_debt_selection' ||
                        documentType.custom_input_logic === 'case_asset_selection' ||
                        documentType.custom_input_logic === 'case_asset_collection' ||
                        documentType.custom_input_logic === 'custom_selection') {
                          <mat-panel-title class="fw-bold">
                            @if (documentType.custom_input_logic === 'case_creditor_selection') {
                              {{ document.documentable?.creditor?.name }}
                            } @else if (documentType.custom_input_logic === 'case_public_debt_selection') {
                              <!-- DEU has some publicOrganization code here, but UNI does not have publicOrganizations-->
                              @if (document.documentable?.reference_number) {
                                ({{ document.documentable.reference_number }})
                              }
                            } @else if (documentType.custom_input_logic === 'case_asset_selection') {
                              {{ document.documentable?.creditor?.name }}
                              @if (document.documentable?.account_number) {
                                ({{ document.documentable.account_number }})
                              }
                            } @else if (documentType.custom_input_logic === 'case_asset_collection') {
                              {{ document.name }}
                            } @else if (documentType.custom_input_logic === 'custom_selection') {
                              {{ document.name }}
                            }
                            @if (document.approval_status === 'pending') {
                              <mat-icon color="accent">error</mat-icon>
                            } @else if (document.approval_status === 'accepted') {
                              <mat-icon color="primary">check_circle</mat-icon>
                            } @else if (document.approval_status === 'rejected') {
                              <mat-icon color="warn">warning</mat-icon>
                            }
                          </mat-panel-title>
                        }
                      </mat-expansion-panel-header>
                      <!-- Document Uploader -->
                      <div class="row">
                        @if (!document.editing && !document.updating) {
                          <div class="col-12">
                            <div class="row justify-content-end">
                              @if (documentType?.document_type_requests?.length && !(document.files?.length || document.compiled_file)) {
                                <div class="col-12 mb-2 row justify-content-end">
                                  <div class="col-auto">
                                    <button type="button" mat-button color="primary"
                                            (click)="deleteDocumentTypeRequest(documentType, document.document_request, document)">
                                      {{ 'CASES.single.documents.list.document.actions.cancel_document_request' | translate }}
                                    </button>
                                  </div>
                                </div>
                              }
                              @if (documentType.custom_input_logic === 'custom_selection') {
                                <div class="col-12 mb-2 row justify-content-end">
                                  <div class="col-auto">
                                    <button type="button" mat-button color="primary"
                                            (click)="editDocument(documentType, document, true)">
                                      {{ 'CASES.single.documents.list.document.actions.edit' | translate }}
                                    </button>
                                  </div>
                                </div>
                              }
                              <div class="col-auto">
                                <button type="button" mat-button color="primary" (click)="mergeDocumentFiles(document)">
                                  {{ 'CASES.single.documents.list.document.actions.merge' | translate }}
                                </button>
                              </div>
                              @if (documentType.requestable) {
                                <div class="col-auto">
                                  <mat-checkbox color="primary" [checked]="document.completed_at"
                                                [labelPosition]="'after'"
                                                (change)="toggleDocumentComplete($event, documentType, document)">
                                    {{ 'CASES.single.documents.list.document.actions.complete.true' | translate }}
                                  </mat-checkbox>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (uploadForm) {
                          <form class="form w-100"
                                [formGroup]="uploadForm"
                                (ngSubmit)="uploadFiles(uploadForm, documentType, document)"
                          >
                            <div class="col-12">
                              <div class="row">
                                @if (document.editing) {
                                  <div class="col-8 mt-2">
                                    <mat-form-field [appearance]="'outline'" subscriptSizing="dynamic" class="w-100">
                                      <mat-label>{{ 'SHARED.name' | translate }}</mat-label>
                                      <input matInput type="text" formControlName="name">
                                      @if (uploadForm.get('name').invalid) {
                                        <mat-error>{{ "SHARED.field-required" | translate }}</mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <div class="col-4 row justify-content-end ml-auto" style="height: min-content">
                                    <div class="col-auto mt-2">
                                      <button type="button" mat-button color="primary"
                                              (click)="editDocument(documentType, document, false)">
                                        {{ "SHARED.cancel" | translate }}
                                      </button>
                                    </div>
                                    <div class="col-auto mt-2">
                                      <button type="button" mat-button color="primary"
                                              (click)="updateDocument(documentType, uploadForm, document)">
                                        {{ "SHARED.save" | translate }}
                                      </button>
                                    </div>
                                  </div>
                                } @else {
                                  <div class="col-12 col-md-6 col-xl-4">
                                    <div class="form-group">
                                      <!-- <label -->
                                      <!--   [for]="'doc_type_upload_file_' + documentType.id">{{ "DOCUMENTS.upload_documents" | translate }}</label> -->
                                      <div class="input-group">
                                        <div class="custom-file">
                                          @if (inputType === 'dropzone') {
                                            <!--                          <mat-form-field appearance="fill" [id]="'doc_type_upload_file_' + documentType.id"-->
                                              <!--                                          (change)="fileSelected($event, documentType, document)">-->
                                              <!--                            <ngx-mat-dropzone>-->
                                              <!--                              <input type="file" fileInput multiple [formControl]="fileInput"/>-->
                                              <!--                            </ngx-mat-dropzone>-->
                                              <!--                            <mat-icon matSuffix color="primary">cloud_upload</mat-icon>-->
                                              <!--                          </mat-form-field>-->
                                          }
                                          @if (inputType === 'default') {
                                            <input multiple type="file" class="custom-file-input"
                                                   [id]="'doc_type_upload_file_' + documentType.id + '_' + document.id"
                                                   (change)="fileSelected($event, documentType, document)"/>
                                            <label class="custom-file-label" style="width: auto;"
                                                   [for]="'doc_type_upload_file_' + documentType.id  + '_' + document.id">
                                              {{ 'DOCUMENTS.choose_file' | translate }}
                                            </label>
                                          }
                                        </div>
                                      </div>
                                      @if (uploadForm.get('app_document_id').value === document.id) {
                                        @for (file of selectedUploadFiles; track file.index) {
                                          <div class="d-flex justify-content-between align-items-center">
                                            <p class="m-0 uploaded-file-name">{{ file.name }}</p>
                                            <button type="button" mat-icon-button color="warn"
                                                    (click)="removeSelectedFile(file.index)">
                                              <mat-icon class="text-danger mat-icon" aria-hidden="false"
                                                        aria-label="Example home icon">
                                                remove_circle
                                              </mat-icon>
                                            </button>
                                          </div>
                                        }
                                      }
                                    </div>
                                  </div>
                                  @if (!document.updating
                                  && uploadForm.get('app_document_type_id').value === documentType.id
                                  && selectedUploadFiles.length) {
                                    <div class="col-auto ml-auto mt-2 mt-md-0">
                                      <app-spinner-btn [loading]="isUploading" [name]="'SHARED.submit' | translate">
                                      </app-spinner-btn>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          </form>
                        }
                        <!-- Compiled File // TODO: remove duplication -->
                        @if (document.compiled_file) {
                          <div class="col-12 pb-1" [formGroup]="formDocumentFile"
                               style="border-bottom: 1px solid gray">
                            <div class="row">
                              <div class="col-1"></div>
                              @if (document.compiled_file.editing) {
                                <div class="col-7 mt-3">
                                  <app-input type="text" formControlName="name" [appearance]="'outline'"
                                             [fullWidth]="true"
                                             [label]="'SHARED.model.name' | translate" [extraLabel]="false">
                                  </app-input>
                                </div>
                                <div class="col-4 row justify-content-end ml-auto mt-3" style="height: min-content">
                                  <div class="col-auto">
                                    <button type="button" mat-button color="primary"
                                            (click)="toggleDocumentFileEdit(documentType, document.compiled_file, false, document)">
                                      {{ "SHARED.cancel" | translate }}
                                    </button>
                                  </div>
                                  <div class="col-auto mt-2 mt-xl-0">
                                    <button type="button" mat-button color="primary"
                                            (click)="updateDocumentFile(documentType, document, document.compiled_file)">
                                      {{ "SHARED.save" | translate }}
                                    </button>
                                  </div>
                                </div>
                              } @else {
                                <div class="col-7 mt-3">
                                  <div class="row">
                                    <div class="col-12">
                                      <button type="button" mat-button color="primary"
                                              (click)="selectPreviewFile(document.compiled_file)">
                                        {{ document.compiled_file.name }}.{{ document.compiled_file.extension }}
                                      </button>
                                    </div>
                                    <div class="col-12">
                                      <button type="button" mat-button color="primary"
                                              (click)="downloadFile($event, document.compiled_file)">
                                        {{ "CASES.single.download" | translate }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-4 row justify-content-end ml-auto mt-1" style="height: min-content">
                                  <div class="col-auto mt-2">
                                    <button type="button" mat-raised-button color="warn"
                                            (click)="deleteFile(documentType, document, document.compiled_file)">
                                      {{ "SHARED.delete" | translate }}
                                    </button>
                                  </div>
                                  <div class="col-auto mt-2">
                                    <button type="button" mat-button color="primary"
                                            (click)="toggleDocumentFileEdit(documentType, document.compiled_file, true, document)">
                                      {{ "SHARED.edit" | translate }}
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        <!-- File List -->
                        <div cdkDropList [cdkDropListData]="document.files" class="col-12 mt-3"
                             (cdkDropListDropped)="updateDropList($event, document)">
                          <div class="row">
                            @for (documentFile of document.files; track documentFile) {
                              <div cdkDrag [cdkDragData]="documentFile" [formGroup]="formDocumentFile"
                                   class="col-12">
                                <div class="row mb-3">
                                  @if (!documentFile.compiled_for_doc_id) {
                                    <div class="col-1 d-flex justify-content-center align-items-center">
                                      <div class="document-file-order-handle" cdkDragHandle>
                                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                                          <path
                                            d="M10 9h5V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                                          <path d="M0 0h44v24H0z" fill="none"></path>
                                        </svg>
                                      </div>
                                    </div>
                                    @if (documentFile.editing) {
                                      <div class="col-7">
                                        <div class="row">
                                          <div class="col-12 col-xl-6">
                                            <app-input type="text" formControlName="name" [appearance]="'outline'"
                                                       [fullWidth]="true"
                                                       [label]="'SHARED.model.name' | translate" [extraLabel]="false">
                                            </app-input>
                                          </div>
                                          @if (caseDocumentTypeCategories?.length) {
                                            <div class="col-12 col-xl-6">
                                              <app-input type="select"
                                                         formControlName="app_document_type_id" appearance="outline"
                                                         [searchable]="true"
                                                         [label]="'Type' | translate"
                                                         [selectOptions]="caseDocumentTypeCategories"
                                                         [optGroupProperty]="'document_types'"
                                                         [optGroupLabel]="'name_es'"
                                                         [selectLabel]="'name_' + currentLanguage" [selectValue]="'id'"
                                                         class="full-width"
                                                         [showClear]="false" [fullWidth]="true">
                                              </app-input>
                                            </div>
                                          }
                                          <div class="col-12 col-xl-6">
                                            @if (case.joint_application) {
                                              <app-input type="select"
                                                         formControlName="user_id"
                                                         appearance="outline" [fullWidth]="true"
                                                         [label]="'Uploaded by'" [selectLabel]="'label'"
                                                         [selectValue]="'value'"
                                                         [selectOptions]="[{label: 'Client', value: case.user_id},{label: 'Partner', value: case.partner_user_id}]">
                                              </app-input>
                                            } @else {
                                              <app-input type="select"
                                                         formControlName="user_id"
                                                         appearance="outline" [fullWidth]="true" [searchable]="true"
                                                         [label]="'Uploaded by'" [selectLabel]="'label'"
                                                         [selectValue]="'value'"
                                                         [selectOptions]="[{label: 'Client', value: case.user_id}]">
                                              </app-input>
                                            }
                                          </div>
                                          <!-- Documentable Selection -->
                                          @if (formDocumentFile.get('custom_input_logic').value) {
                                            <div class="col-12 col-xl-6">
                                              @if (formDocumentFile.get('documentable_type').value === 'case_creditor' &&
                                              caseCreditorOptions?.length) {
                                                <app-input type="select" formControlName="documentable_id"
                                                           appearance="outline" [searchable]="true"
                                                           [label]="'Case creditor'"
                                                           [selectOptions]="caseCreditorOptions" selectLabel="label"
                                                           selectValue="value" class="full-width" [showClear]="false"
                                                           [fullWidth]="true">
                                                </app-input>
                                              } @else if (formDocumentFile.get('documentable_type').value === 'case_public_debt' &&
                                              casePublicDebtOptions?.length) {
                                                <app-input type="select" formControlName="documentable_id"
                                                           appearance="outline"
                                                           [searchable]="true"
                                                           [label]="'Public debt'"
                                                           [selectOptions]="casePublicDebtOptions"
                                                           selectLabel="label" selectValue="value" class="full-width"
                                                           [showClear]="false" [fullWidth]="true">
                                                </app-input>
                                              } @else if (formDocumentFile.get('documentable_type').value === 'case_asset' &&
                                              caseAssetOptions?.length) {
                                                <app-input type="select"
                                                           formControlName="documentable_id" appearance="outline"
                                                           [searchable]="true"
                                                           [label]="'Bank account'" [selectOptions]="caseAssetOptions"
                                                           selectLabel="label" selectValue="value" class="full-width"
                                                           [showClear]="false" [fullWidth]="true">
                                                </app-input>
                                              }
                                            </div>
                                            @if (formDocumentFile.get('custom_input_logic').value === 'custom_selection') {
                                              <div class="col-12 col-xl-6">
                                                <app-input
                                                  type="select"
                                                  formControlName="app_document_id" appearance="outline"
                                                  [searchable]="true"
                                                  [label]="'Custom document'" [selectOptions]="customDocuments"
                                                  selectLabel="name" selectValue="id" class="full-width"
                                                  [showClear]="false" [fullWidth]="true">
                                                </app-input>
                                              </div>
                                            }
                                          }
                                        </div>
                                      </div>
                                      <div class="col-4 row justify-content-end ml-auto" style="height: min-content">
                                        <div class="col-auto">
                                          <button type="button" mat-button color="primary"
                                                  (click)="toggleDocumentFileEdit(documentType, documentFile, false, document)">
                                            {{ "SHARED.cancel" | translate }}
                                          </button>
                                        </div>
                                        <div class="col-auto mt-2 mt-xl-0">
                                          <button type="button" mat-button color="primary"
                                                  (click)="updateDocumentFile(documentType, document, documentFile)">
                                            {{ "SHARED.save" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    } @else {
                                      <div class="col-7 mt-2">
                                        <div class="row">
                                          <div class="col-12 row align-items-center">
                                            <div class="col-auto">
                                              <button type="button" mat-button color="primary"
                                                      class="h-100 preview-button"
                                                      (click)="selectPreviewFile(documentFile)">
                                                {{ documentFile.name }}.{{ documentFile.extension }}
                                              </button>
                                            </div>
                                            <div class="col-auto d-flex">
                                              <label class="mx-0 my-auto">
                                                @if (documentFile.fileable_approved === null) {
                                                  {{ 'CASES.single.documents.list.file.approval_status.pending' | translate }}
                                                } @else if (documentFile.fileable_approved === true) {
                                                  {{ 'CASES.single.documents.list.file.approval_status.accepted' | translate }}
                                                } @else if (documentFile.fileable_approved === false) {
                                                  {{ 'CASES.single.documents.list.file.approval_status.rejected' | translate }}
                                                }
                                              </label>
                                            </div>
                                            @if (appEnv === 'local' || [1, 64684, 713839].includes(case?.id)) {
                                              <div class="col-auto">
                                                <button mat-button color="primary" [matMenuTriggerFor]="menu">
                                                  AI
                                                </button>
                                                <mat-menu #menu="matMenu">
                                                  <button mat-menu-item
                                                          (click)="openAIVisionModal('recommendation', documentFile)">
                                                    View AI recommendation
                                                  </button>
                                                  <button mat-menu-item
                                                          (click)="openAIVisionModal('summary', documentFile)">
                                                    View AI summary
                                                  </button>
                                                </mat-menu>
                                              </div>
                                            }
                                          </div>
                                          <div class="col-12 mt-2 row">
                                            @if (documentFile.fileable_approved === false) {
                                              <div class="col-12 col-xl-4">
                                                <small>
                                                  {{ 'CASES.single.documents.list.file.reject_reason' | translate }}
                                                  : {{ documentFile.fileable_reject_reason }}
                                                </small>
                                              </div>
                                            }
                                            @if (documentFile.mime_type.includes('image')) {
                                              <div class="col-auto">
                                                <button type="button" mat-button color="primary"
                                                        (click)="openEditModal(document, documentFile)">
                                                  {{ "CASES.single.edit_image" | translate }}
                                                </button>
                                              </div>
                                            }
                                            <div class="col-auto">
                                              <button type="button" mat-button color="primary"
                                                      (click)="downloadFile($event, documentFile)">
                                                {{ "CASES.single.download" | translate }}
                                              </button>
                                            </div>
                                            @if (documentFile.converted_pdf) {
                                              <div class="col-auto">
                                                <button type="button" mat-button
                                                        color="primary"
                                                        (click)="downloadFile($event, documentFile.converted_pdf)">
                                                  {{ "CASES.single.download" | translate }} PDF
                                                </button>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-4 row justify-content-end ml-auto" style="height: min-content">
                                        <div class="col-auto mt-2">
                                          @if (documentType.requestable && documentFile.fileable_approved !== true) {
                                            <button type="button" mat-raised-button class="primary-button"
                                                    (click)="updateDocumentFileStatus(documentType, document, documentFile, true)">
                                              {{ "SHARED.accept" | translate }}
                                            </button>
                                          }
                                          @if (documentType.requestable && documentFile.fileable_approved !== false) {
                                            <button type="button" mat-raised-button color="warn"
                                                    (click)="updateDocumentFileStatus(documentType, document, documentFile, false)">
                                              {{ "SHARED.decline" | translate }}
                                            </button>
                                          }
                                        </div>
                                        <div class="col-auto mt-2">
                                          <button type="button" mat-raised-button color="warn"
                                                  (click)="deleteFile(documentType, document, documentFile)">
                                            {{ "SHARED.delete" | translate }}
                                          </button>
                                        </div>
                                        <div class="col-auto mt-2">
                                          <button type="button" mat-button color="primary"
                                                  (click)="toggleDocumentFileEdit(documentType, documentFile, true, document)">
                                            {{ "SHARED.edit" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <!-- No Data -->
                        @if (!document.files.length) {
                          <div class="col-12 mt-4">
                            <h5 class="text-center user-document-list">
                              {{ "CASES.single.no_files_uploaded" | translate }}
                            </h5>
                          </div>
                        }
                      </div>
                    </mat-expansion-panel>
                  }
                </mat-expansion-panel>
              }
            </mat-expansion-panel>
          }
        </ng-container>
      }
    </mat-accordion>
  </mat-expansion-panel>
}
